import type { RouteRecordRaw } from 'vue-router';

/**
 * Rutas del módulo de tutoriales
 * Estas rutas se integran en /private/tutorials
 */
export const tutorialsRoutes: RouteRecordRaw[] = [
  {
    path: "tutorials",
    name: "Tutoriales",
    component: () => import("@/modules/tutorials/views/TutorialsListView.vue"),
    meta: {
      requiresAuth: true,
      title: "Interactive Tutorials",
      icon: "mdi-school-outline",
    },
  },
];
